import type { IFieldConfiguration } from '@sravni/cosago-react-library/lib/types';

import type { TAdditionalDataFormFields } from 'entities/creditForm';

import {
  Education,
  MaritalStatus,
  NumberOfDependents,
  AdditionalPhoneOwner,
  CarAvailability,
  PropertyTypeAvailability,
  AdditionalPhone,
  Snils,
  AdditionalPhoneOwnerFioField,
} from './ui/fields';

export interface IAdditionalInfoMobileConfig extends Omit<IFieldConfiguration, 'fieldName'> {
  fieldName: keyof TAdditionalDataFormFields;
}

export const FormFieldsControls: Record<keyof TAdditionalDataFormFields, React.ReactNode> = {
  education: Education,
  maritalStatus: MaritalStatus,
  numberOfDependents: NumberOfDependents,
  additionalPhoneOwner: AdditionalPhoneOwner,
  additionalPhoneOwnerFullName: AdditionalPhoneOwnerFioField,
  carAvailability: CarAvailability,
  carAvailabilityToggleEnabled: null,
  propertyTypeAvailability: PropertyTypeAvailability,
  propertyTypeAvailabilityToggleEnabled: null,
  additionalPhone: AdditionalPhone,
  snils: Snils,
};

export const FormFieldsNavigationSequence: IAdditionalInfoMobileConfig[] = [
  {
    fieldName: 'education',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'maritalStatus',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'numberOfDependents',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'additionalPhoneOwner',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'carAvailability',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'propertyTypeAvailability',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'additionalPhone',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'snils',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'additionalPhoneOwnerFullName',
    required: false,
    checkShouldMoveToNextField: false,
  },
];
